import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import { Field, Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import ReactSelect from "react-select";
import {
  Button,
  CardBody,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  UncontrolledTooltip,
  Card,
} from "reactstrap";

import DeleteIcon from "assets/icon/icon-icon-options-delete.svg";
import DeleteHoverIcon from "assets/icon/icon-icon-options-delete-hover.svg";
import Calendar from "assets/icon/calendar-icon.svg";
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import InfoIcon from 'assets/icon/AddWholeSaler.svg';
import HoverImage from "react-hover-image/build";
import moment from "moment";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { toast } from "react-toastify";
import Question from "assets/icon/icon-question-mark.svg";
import Tooltip from "react-tooltip-lite";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import NDCList from "components/NDCList";
import * as Yup from "yup";
import useAxios from "hooks/useAxios";
import { parse } from "@fortawesome/fontawesome-svg-core";
import Loader from "components/Loader";
import Attachments_hover from "assets/icon/icon-icon-options-attachment_hover.svg";
import Attachments from "assets/icon/icon-icon-options-attachment.svg";
import Drawer from "components/Drawer";
import Addattachments from "components/AddAttachmentsSerachOrder";
import ProgramNotes from "components/ProgramNotes";
import { First } from "react-bootstrap/esm/PageItem";
import { forEach } from "lodash";
import useContextService from "hooks/useContextService";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import complete from "assets/icon/complete-icon.svg";
import Download from 'assets/icon/download.svg';
import DownlaodHower from 'assets/icon/download_hover.svg';


let hasDatePopupOpen = false;
let accountTypeData = [];
let accountNumberData = [];
let rowForEdit = {};
let errNdc = "Covered Entity Name is a required field";
let errqtyOrder1 = "Qty Ordered is a required field";
const AddPurchaseOrder = (props) => {
  const { orgId, toggle, refetch, iseditflag, SelectedAccumulator } = props;
  const {
    states: { searchOrder },
    setStates,
  } = useContextService();
  const { search, coveredEntity, searchTerms, claimStatusID } = searchOrder;
  const { coveredEntityIDs } = searchTerms;
  const API = useAxios();
  const [state, updateState] = useState({
    rows: [],
  });
  //const [accountTypeData,setAccountTypeData] = useState([]);
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  const initialValues = {
    creditReturn: isCreditReturnChecked,
    ndc: "",
    accumulation: "",
    qtyordered: "",
    qtyreceived: "",
    qtybilled: "",
    packagesprice: "",
    totalprice: "",
    comment: "",
  };

  // const validationSchema = Yup.object({
  //   //  ndc: Yup.string().required("NDC Description is a required field"),
  //   //accumulation: Yup.string().required('Required'),
  //   qtyordered: Yup.number().when([], {
  //     is: () => !isCreditReturnChecked, // Check if Credit/Return is NOT checked
  //     then: Yup.number()
  //       .required("Qty Ordered is a required field")

  //       .test(
  //         "is-valid-number",
  //         "Qty Ordered must be a valid number",
  //         (value) => {
  //           return value === "" || !isNaN(value);
  //         }
  //       ),
  //     otherwise: Yup.number().notRequired(), // Skip validation when Credit/Return is checked
  //   }),
  //   // qtyreceived: Yup.number()
  //   // .when([], {
  //   //   is: () => !isCreditReturnChecked, // Check if Credit/Return is NOT checked
  //   //   then: Yup.number()
  //   //      .required('Qty Received is required')
  //   //     .test('is-valid-number', 'Qty Received must be a valid number', (value) => {
  //   //       return value === "" || !isNaN(value);
  //   //     }),
  //   //   otherwise: Yup.number().notRequired(), // Skip validation when Credit/Return is checked
  //   // }),
  //   // qtybilled: Yup.string().required("Qty Billed is required"),
  //   // packagesprice: Yup.string().required("Package Price required"),
  //   // totalprice: Yup.string().required('Required'),
  //   // comment: Yup.string().required('Required')
  // });
  const [isflag, setIsflag] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [orderDate, setOrderDate] = useState(null);
  const [receivedDate, setReceivedDate] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [poid, setPoid] = useState(null);
  const [invoiceid, setinvoiceid] = useState('');
  // const [wholeAccIdError, setWholeAccIdError] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [invoiceError, setInvoiceError] = useState(false);
  const [selectedNdc, setSelectedNdc] = useState(null);
  const [selectedNdcid, setSelectedNdcID] = useState(0);
  const [err, setError] = useState(false);
  const [wholesaler, setWholeSaler] = useState([]);
  const [selectedWhosaler, setSelectedWhosaler] = useState("");
  const [accountType, setAccountType] = useState([]);
  const [selectedAccountType, setAccountTypeSelected] = useState("");
  const [selectedaccountNumber, setSelectedaccountNumber] = useState("");
  const [orderstatus, setOrderstatus] = useState("");
  // const [selectedNDC, setSelectedNDC] = useState(null);
  const [isCreditReturnChecked, setIsCreditReturnChecked] = useState(false);
  const [qtyBilled, setQtyBilled] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [qtyReceiver, setQtyReceived] = useState("");
  const [receivedBilled, setReceivedBilled] = useState("");
  const [billqty, setBillQty] = useState("");
  const [packageprice, setPackageprice] = useState("");
  const [isEditable1, setIsEditable1] = useState(false);
  const [ndcexisterror, setndcexistErrors] = useState('');
  const [selectedWhosalererror, setSelectedWhosalerError] = useState("");
  const [accountTypeError, setAccountTypeError] = useState("");
  const [accountError, setAccountError] = useState("");
  const [orderDateError, setorderDateError] = useState("");
  const [invoiceDateError, setInvoiceDateError] = useState("");
  const [invoiceError, setInvoiceError] = useState("");
  const [errqtyOrder, seterrqtyOrder] = useState(errqtyOrder1)




  const toggleEdit = (item, isEdit = true) => {
    debugger;
    let tempData = [...rows];
    tempData = tempData.map((row) => {
      // row.isEdit = false;
      if (row.id == item?.id && isEdit) {
        setIsEditable(row.id);
        setIsEditable1(true);
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
  };
  console.log(isEditable, "isedittable");
  const formikRef = useRef(null);

  const savePanelUpdateRow = (item, values) => {
  const updatedRows = state.rows.map((row) => {
    if (row.ndc !== item.ndc) {
      return row;
    }
    const qtyreceived = values.qtyreceived === "" ? 0 : Number(values.qtyreceived);
    const qtybilled = values.qtybilled === "" ? 0 : Number(values.qtybilled);
    const packagesprice = values.packagesprice === "" ? 0 : Number(values.packagesprice);
    return {
      ...row,
      qtyreceived,
      qtybilled,
      packagesprice,
      totalprice: qtybilled * packagesprice,
    };
  });
  updateState({
    rows: updatedRows,
  });
  setIsEditable(false);
};

  // useEffect(()=> {
  //   const value = values.qtyordered;
  //   if (!isCreditReturnChecked) {
  //     if (!value || value === "") {
  //       setErrormess("Qty Ordered is a required field");
  //     } else if (isNaN(value)) {
  //       setErrormess("Qty Ordered must be a valid number");
  //     } else {
  //       setErrormess(""); // Clear error when valid
  //     }
  //   } else {
  //     setErrormess(""); // No error when credit return is checked
  //   }
  // }, [values.qtyordered, isCreditReturnChecked]);

  const oncancal = () => {
    setIsEditable(false);
  };
  useEffect(() => {
    fetchWholesaler();
    fetchAccountType();
    accountNumberData = [];
    // SeterrorNDC(true);
  }, []);
  const [AddAtachments, setAddAtachments] = useState(false);

  const manvalPharmacy = () => {
    setAddAtachments(!AddAtachments);
  };
  const fetchWholesaler = async () => {
    //setLoading(true);
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/WholesalersByacId/${SelectedAccumulator}`, {
        hasDefaultURL: true,
      });
      // console.log(data, "Ordering wholesalar");
      if (data) {
        setWholeSaler(data);
      }
      // setLoading(false);
    } catch (error) {
      //setLoading(false);
      //. console.log(error.Message);
    }
  };

  const updateRowValue = (value, col) => {
    debugger;
    const tempRow = { ...rowForEdit };
    //setIshiddenflag(false);
    tempRow[col] = value;
    rowForEdit = tempRow;
  };
  const checkValidation1 = (hasTrue) => {
    debugger;
    if (selectedWhosaler == "") {
      setSelectedWhosalerError("Wholesaler is required field");

    }
    else {
      setSelectedWhosalerError("");
    }
    if (selectedAccountType == "") {
      setAccountTypeError("Account Type is a required field");


    }
    else {
      setAccountTypeError("");
    }
    if (selectedaccountNumber == "" || selectedaccountNumber == "-Select-") {
      setAccountError("Acct # is a required field");


    }
    else {
      setAccountError("");
    }
    if (orderDate == null && isCreditReturnChecked == false) {
      setorderDateError("Order Date is required field");
      setInvoiceError("");
      setInvoiceDateError("");
      return false;
    }
    else {
      setorderDateError("");
    }
    setInvoiceDateError("");
    setInvoiceError("")

  }
  const checkValidation2 = () => {
    debugger;
    if (invoiceDate == null) {
      setInvoiceDateError("Invoiced Date is a required field");
    }
    else {
      setInvoiceDateError("");
    }
    if (invoiceid == "") {
      setInvoiceError("Invoice# is a required field");
      return true;
    }
    else {
      setInvoiceError("");
    }


  }


  const handlesave = async () => {
    debugger
    if (checkValidation1() == false) {
      return true;
    }
    let orderstatusdesc = "save";
    let payload = {};
   
    payload.ReceivedDate = (receivedDate != null || receivedDate != undefined) ? moment(receivedDate, "MM/DD/YYYY").format("YYYY-MM-DD") : null;
    payload.InvoiceDate = (invoiceDate != null || invoiceDate != undefined) ? moment(invoiceDate, "MM/DD/YYYY").format("YYYY-MM-DD") : null;
    payload.ItemOrderedDate = (orderDate != null || orderDate != undefined) ? moment(orderDate, "MM/DD/YYYY").format("YYYY-MM-DD") : null;
    payload.AccountTypeID = selectedAccountType;
    payload.InvoiceNumber = invoiceid;
    payload.DrugID = selectedNdcid;
    payload.PONumber = poid;
    payload.WholesalerId = selectedWhosaler;
    payload.AccountNumber = selectedaccountNumber;
    payload.AddPOOrderModelfilter = state.rows;
   
    try {
      setLoading(true);
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/PurchaseOrder/AddPurchaseOrder/${SelectedAccumulator}/${orderstatusdesc}`,
        payload,
        { hasDefaultURL: true }
      );
      if (data) {
        if (data.error) {
          toast.error(result.data.message);
          setLoading(false);
        } else {
          toast.success("Order Added successfully");
          toggle();
          refetch(true);
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handelSelectWholeSaler = (e) => {
    const { value } = e.target;
    if (value.length > 0) {
      setSelectedWhosalerError("");
      setAccountTypeSelected("");
      setSelectedaccountNumber("");
      setSelectedWhosaler(value);
    }
    // else{
    //   setSelectedWhosalerError("Wholesaler is required field");
    // }
    // console.log(value,"value")

  };
  const handlepharmacy = (e) => {
    var poid = e.target.value;
    setPoid(poid);
    setError("");
  };
  const handleinvoice = (e) => {
    var invoice = e.target.value;
    setinvoiceid(invoice);
    setInvoiceError("");
  };
  const handleReceiveDate = (receivedDate) => {
    var recdate = moment(new Date(receivedDate)).format("MM/DD/YYYY");
    setReceivedDate(recdate);

  };
  const handleOrderDateRaw = (e) => {
    debugger;
    var val = e.target.value;
    setReceivedDate(null);
    setInvoiceDate(null);
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && orderDate !== null) {
      setOrderDate(null);
    }

    if (isValid) {
      handleOrderDate(e.target.value);
    }
  };
  const handleReceiveDateRaw = (e) => {
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && receivedDate !== null) {
      setReceivedDate(null);
    }

    if (isValid) {
      handleReceiveDate(e.target.value);
    }
  };
  const handleInvoiceDateRaw = (e) => {
    var mxdt = new Date(orderDate);
    var valdt = new Date();
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && invoiceDate !== null) {
      setInvoiceDate(null);
    }

    if (isValid && val <= valdt && val >= mxdt) {
      handleInvoiceDate(e.target.value);
    }
  };
  const handleInvoiceDate = (invoiceDate) => {
    var invodate = moment(new Date(invoiceDate)).format("MM/DD/YYYY");

    if (invodate !== null) {
      setInvoiceDate(invodate);
      setInvoiceDateError("");
    }
  };
  const validations = () => {
    if (
      wholeid == "" ||
      wholeid === undefined ||
      wholeaccountid === "" ||
      wholeaccountid === undefined ||
      orderDate == null ||
      invoiceDate == null ||
      orderinvoice === "" ||
      orderinvoice === undefined
    ) {
      setError(true);
      setWholeAccIdError(true);
      // setInvoiceError(true);
      return true;
    }
    return false;
  };
  const handleorder = async () => {
    debugger;
    if (checkValidation1()) {
      return true;
    }
    if (checkValidation2()) {
      return true;
    }

    let orderdesc = "Complete";
    let payload = {};
    
    payload.ReceivedDate = (receivedDate != null || receivedDate != undefined) ? moment(receivedDate, "MM/DD/YYYY").format("YYYY-MM-DD") : null;
    payload.InvoiceDate = (invoiceDate != null || invoiceDate != undefined) ? moment(invoiceDate, "MM/DD/YYYY").format("YYYY-MM-DD") : null;
    payload.ItemOrderedDate = (orderDate != null || orderDate != undefined) ? moment(orderDate, "MM/DD/YYYY").format("YYYY-MM-DD") : null;
    payload.AccountTypeID = selectedAccountType;
    payload.InvoiceNumber = invoiceid;
    payload.DrugID = selectedNdcid;
    payload.PONumber = poid;
    payload.WholesalerId = selectedWhosaler;
    payload.AccountNumber = selectedaccountNumber;
    payload.AddPOOrderModelfilter = state.rows;

    try {
      setLoading(true);
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/PurchaseOrder/AddPurchaseOrder/${SelectedAccumulator}/${orderdesc}`,
        payload,
        { hasDefaultURL: true }
      );
      if (data) {
        if (data.error) {
          toast.error(result.data.message);
          setLoading(false);
        } else {
          toast.success("Order Completed successfully");
          toggle();
          refetch(true);
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const fetchAccountNumber = async (value) => {
    let accid = SelectedAccumulator[0];

    try {
      const { data } = await API.get(
        `SBConfig/TypeStatus/AccountNumbers/${parseInt(
          selectedWhosaler
        )}/${parseInt(value)}/${accid}`,
        { hasDefaultURL: true }
      );

      if (data) {
        for (var x in data) {
          accountNumberData.push({
            id: data[x].accountCode,
            description: data[x].accountCode,
          });
        }
        // if(accountTypeId)
        // {
        //   searchOrder.searchTerms.accountTypeId=accountTypeId;
        //   updateStates(searchOrder);
        // }
        //setAccountType(data);
      } else {
        //setAccountType([]);
      }
    } catch (err) { }
  };
  const fetchAccountType = async () => {

    try {
      const { data } = await API.get(`SBConfig/TypeStatus/accountType`, {
        hasDefaultURL: true,
      });

      if (data) {
        for (var x in data) {
          accountTypeData.push({
            id: data[x].id,
            description: data[x].description,
          });
        }
        // if(accountTypeId)
        // {
        //   searchOrder.searchTerms.accountTypeId=accountTypeId;
        //   updateStates(searchOrder);
        // }
        setAccountType(data);
      } else {
        setAccountType([]);
      }
    } catch (err) { }
  };
  const handleAccountTypeChange = (e) => {
    const { value } = e.target;
    if (value.length > 0) {
      setAccountTypeSelected(value);
      accountNumberData = [];
      fetchAccountNumber(value);
      setAccountTypeError("");
    } //else {
    //   setAccountTypeError("Account Type is a required field");
    // }
  };

  const onHandleDelete = (id) => {
    const updatedRows = rows.filter((item) => item.id !== id);
    setState({
      rows: updatedRows,
    });
    //setIsflag(false); //SBS-4397 Ticket
  };
  const { rows } = state;

  const handleSubmit = async (val, actions) => {
    debugger;
    if (val.ndc === '' || val.ndc === null) {
      setndcexistErrors("NDC Description is a required field");
      return true;
    }
    if (state.rows.some(row => row.ndc == val.ndc)) {
      setndcexistErrors("NDC Already Exists!");
      return true;
    }
    if ((!val.qtyordered || val.qtyordered === "") && !isCreditReturnChecked) {
      seterrqtyOrder("Qty Ordered is a required field");
      if (!val.qty)
        actions.setTouched({ ...actions.touched, qtyordered: true });
      return;
    }
    
    else {
      setIsEditable(false);
      setndcexistErrors('');
      seterrqtyOrder("");
      const { resetForm, setSubmitting } = actions;
      val.id = "id" + Math.random().toString(16).slice(2);
      val.packagesprice = val.packagesprice ? val.packagesprice : 0;
      val.qtybilled = val.qtybilled ? val.qtybilled : 0;
      val.qtyordered = val.qtyordered ? val.qtyordered : 0;
      val.qtyreceived = val.qtyreceived ? val.qtyreceived : 0;
      val.totalprice = val.packagesprice * val.qtybilled;
      console.log("Before setState:", state.rows);

      setState({
        rows: [...state.rows, { ...val }],
      });
      console.log("After setState:", state.rows);

      resetForm();
      setIsflag(true);
      setSubmitting(false);
      setSelectedNdc(null);
      setQtyBilled("");
    }
    // if (ndc !== null) {
    //   Serror(false);
    //   //handleAccumulation(ndc, setFieldValue);
    // }

    // if(ndcName.length == 0)
    //   {
    //      SeterrorNDC(true)
    //   }
    //   else{
    //     SeterrorNDC(true)
    //   }
  };

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleAccountNumberChange = (e) => {
    debugger;
    const valueAcc = e.target.value;
    // if (valueAcc == "-Select-") {
    //   setAccountError("Acct # is required field");
    // } else 
    if (valueAcc.length > 0) {
      setSelectedaccountNumber(valueAcc);
      setAccountError("");
    }
    else {
      return;
    }
    // else {
    //   setAccountError("Acct # is required field");
    // }
  };
  const handleOrderDate = (orderDate) => {
    debugger;
    var ordate = moment(new Date(orderDate)).format("MM/DD/YYYY");
    if (ordate !== null) {
      setOrderDate(ordate);
      setorderDateError("");
    }
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleNdc = (ndc, setFieldValue) => {
    debugger;
    if (ndc !== null) {
      setSelectedNdc(ndc);
      setSelectedNdcID(ndc.id)
      setFieldValue("ndc", ndc.id.toString());
      setFieldValue("Desc", ndc.description);
      setndcexistErrors('')
      //handleAccumulation(ndc, setFieldValue);
    } else {
      setSelectedNdc(null);
      setFieldValue("ndc", null);
    }
  };
  const handleCredit = (e) => {
    debugger;
    setIsCreditReturnChecked((prev) => !prev);
    setOrderDate(null);
    setInvoiceDate(null);
    setReceivedDate(null);
    setSelectedWhosaler('');
    //setAccountType('');
    setAccountTypeSelected("");
    setSelectedaccountNumber('');
    setPoid("");
    setinvoiceid('');
    setSelectedNdc(null);
    setQtyBilled("");
    setSelectedWhosalerError("");
    setAccountTypeError("")
    setAccountError("");
    setorderDateError("");
    setInvoiceDateError("");
    setInvoiceError("");
    if (formikRef.current) {
      formikRef.current.resetForm();
      setState({ rows: [] });
    }
    if (rows.length > 0) {
      setState({
        rows: [],
      });
    }
  };

  // };
  // const handleCreditChange = (e, setFieldValue) => {
  //   const isChecked = e.target.checked;
  //   setIsCreditReturnChecked(isChecked);

  //   if (isChecked) {
  //     // If Credit/Return is checked, we set qtybilled as negative (if positive)
  //     setFieldValue("qtybilled", Math.abs(e.target.value) * -1);
  //   } else {
  //     // If unchecked, make sure qtybilled is positive
  //     setFieldValue("qtybilled", Math.abs(e.target.value));
  //   }
  // };
  const handleQtyBilledChange = (value, setFieldValue) => {

    let qtyvalue = parseInt(value.target.value);
    if (isCreditReturnChecked) {
      setFieldValue("qtybilled", -Math.abs(qtyvalue));
      setQtyBilled(qtyvalue);
    } else {
      setFieldValue("qtybilled", Math.abs(qtyvalue));
      setQtyBilled(qtyvalue);
    }
  };
  const handlereceievdChange = (value, setFieldValue) => {
    const inputValue = value.target.value;
    if (inputValue === "") {
        setFieldValue("qtyreceived", 0);
        setReceivedBilled(0);
        return;
    }
    const qtyvalue = parseInt(inputValue, 10);
    setFieldValue("qtyreceived", Math.abs(qtyvalue));
    setReceivedBilled(qtyvalue);
};
  const handlbillChange = (value, setFieldValue) => {
    let billvalue = value.target.value;
    setFieldValue("qtybilled", Math.abs(billvalue));
    setBillQty(billvalue);
  }
  const handlepackagepriceChange = (value, setFieldValue) => {
    const inputValue = value.target.value;
    if (inputValue === "") {
        setFieldValue("packagesprice", "");
        setPackageprice(0);
        return;
    }
    const qtypvalue = parseInt(inputValue, 10);
    setFieldValue("packagesprice", Math.abs(qtypvalue));
    setPackageprice(qtypvalue);
  };
  return (
    <div>
      <Card>
        <CardBody>
          {loading && <Loader />}
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            // validationSchema={validationSchema}
            enableReinitialize={true}
            children={(props) => {
              const {
                isSubmitting,
                handleSubmit,
                resetForm,
                setFieldValue,
                errors,
                touched,
              } = props;
              return (
                <>

                  <Row md="auto" hidden={iseditflag}>
                    <Col md={3} className="d-flex">
                      <Col md={7} lg={7} sm={7} xs={7} className="">
                        {" "}
                        <FormGroup className="d-flex">
                          <Label for="credit-return">Credit/Return</Label>
                          <Input
                            id="credit-return"
                            name="credit-return"
                            type="checkbox"
                            className="credit-return"
                            // placeholder="Enter Accumulator Name"
                            autoComplete="off"
                            value={""}
                            checked={isCreditReturnChecked}
                            component={""}
                            onChange={handleCredit}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <Tooltip
                          styles={{ marginLeft: "-14px" }}
                          content={
                            <div className="tip-list-info">
                              <p>
                                <strong>Credit/Return :</strong>
                                <span>
                                  Please check to add Credit Orders/Returns to the
                                  system.
                                </span>
                              </p>
                            </div>
                          }
                          direction="right"
                          tagName="span"
                          className="target"
                          tipContentClassName=""
                          zIndex={99999}
                        >
                          <span className="cursor-pointer text-decoration-underline">
                            <HoverImage
                              src={Question}
                              hoverSrc={Question}
                              style={{ width: "20px", height: "20px" }}
                            ></HoverImage>
                          </span>
                        </Tooltip>
                      </Col>
                    </Col>


                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="wholesalervendor">Wholesaler/Vendor</Label>
                        <Field
                          className="required"
                          id="wholesaler"
                          name="wholesaler"
                          type="select"
                          disabled={iseditflag}
                          // placeholder="Select WholeSaler "
                          autoComplete="off"
                          options={wholesaler}
                          value={selectedWhosaler}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          optionSelected={true}
                          component={FormikSelectField}
                          // onKeyUp={handleStateData}
                          defaultoption="-Select-"
                          keys={{
                            id: "wholesalerId",
                            label: "wholesalerName",
                          }}
                          onChange={(e) => handelSelectWholeSaler(e)}
                        />
                        {selectedWhosalererror ? (
                          <div className="text-danger f-12">
                            {selectedWhosalererror}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      {" "}
                      <FormGroup>
                        <Label for="accounttype">Account Type</Label>
                        <Field
                          className="required"
                          id="accounttype"
                          name="accounttype"
                          type="select"
                          // placeholder="Select"
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          optionSelected={true}
                          component={FormikSelectField}
                          disabled={iseditflag}
                          autoComplete="off"
                          options={accountType}
                          value={selectedAccountType}
                          // component={FormikSelectField}
                          // onKeyUp={handleStateData}
                          defaultoption="-Select-"
                          keys={{
                            id: "id",
                            label: "description",
                          }}
                          onChange={(e) => handleAccountTypeChange(e)}
                        />
                        {accountTypeError ? (
                          <div className="text-danger f-12">
                            {accountTypeError}
                          </div>
                        ) : null}
                        {/* <Input
                      className="required"
                      name="accounttype"
                      //id="accounttype"
                      type="select"
                      value={selectedAccountType}
                      ////component={FormikSelectField}
                      onChange={(e) =>
                        handleAccountTypeChange(e)
                      }
                    >
                      <option value={""}>(All)</option>
                      {accountTypeData.map((accountT) => {
                        const { id, description } = accountT;
                        return (
                          <option key={id} value={id}>
                            {description}
                          </option>
                        );
                      })}
                    </Input> */}
                      </FormGroup>
                    </Col>
                    <Col md={3} sm={3} xs={6}>
                      <FormGroup>
                        <Label for="acct">Acct #</Label>
                        <Input
                          className="required"
                          name="accountNumber"
                          //id="accounttype"
                          type="select"
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          optionSelected={true}
                          component={FormikSelectField}
                          disabled={iseditflag}
                          value={selectedaccountNumber}
                          ////component={FormikSelectField}
                          onChange={(e) => handleAccountNumberChange(e)}
                        >
                          <option>-Select-</option>
                          {accountNumberData.map((accountT) => {
                            const { id, description } = accountT;
                            return (
                              <option key={id} value={id}>
                                {description}
                              </option>
                            );
                          })}

                        </Input>
                        {accountError ? (
                          <div className="text-danger f-12">
                            {accountError}
                          </div>
                        ) : null}

                        {/* <ReactSelect
                      name="acct"
                      id="acct"
                      options={[]}
                      // isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      optionSelected={true}
                      // components={{
                      //     Option, ValueContainer: LimitedChipsContainer
                      // }}
                      isSearchable="true"
                      // onChange={(value, cp) =>
                      //     handleChainPharmacyChange(value, setFieldValue, cp)}
                      // value={selectedOption.optionSelected}
                      className="claim_info"
                      maxMenuHeight={220}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                          width: "100%",
                        }),
                      }}
                    /> */}
                      </FormGroup>
                    </Col>

                    <Col md={1} style={{ marginTop: 36 }}>
                      <div>
                        <Tooltip
                          content={
                            <div className="tip-list-info" style={{ position: "absolute", right: "0" }}>
                              <p>
                                <strong>Acct# :</strong>
                                <span>
                                  If Wholesaler or Acct# is not found navigate
                                  <br /> to Drug Catalog-- Wholesaler to add <br />
                                  Wholesaler Acct information.
                                </span>
                              </p>
                            </div>
                          }
                          direction="left"
                          tagName="span"
                          className="target"
                          tipContentClassName=""
                          zIndex={99999}
                        >
                          <span className="cursor-pointer text-decoration-underline">
                            <HoverImage
                              src={Question}
                              hoverSrc={Question}
                              style={{
                                width: "20px",
                                height: "20px",
                                // marginTop: "37px",
                              }}
                            ></HoverImage>
                          </span>
                        </Tooltip>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="PO">PO #</Label>
                        <Input
                          id="PO"
                          name="PO"
                          type="text"
                          placeholder="Enter PO"
                          autoComplete="off"
                          value={poid}
                          onChange={(e) => {
                            handlepharmacy(e);
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4} className="required-date">
                      <FormGroup>
                        <Label>Order Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <DatePicker
                            id="orderDate"
                            name="orderDate"
                            selected={orderDate}
                            onChange={(e) => {
                              handleOrderDate(e);
                            }}
                            disabled={isCreditReturnChecked}
                            //  minDate={new Date(orderDate)}
                            maxDate={new Date()}
                            onChangeRaw={handleOrderDateRaw}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Select a date"
                            autoComplete="off"
                            className={
                              isCreditReturnChecked
                                ? "required disabled"
                                : "required"
                            }
                            customInput={
                              <ReactInputMask
                                mask="99/99/9999"
                                // minDate={new Date(orderDate)}
                                value={orderDate}
                              // maskChar=''
                              />
                            }
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("orderDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {/* {err && orderDate === null && (
                          <div className="text-danger f-12">
                            Please select a Order Date
                          </div>
                        )} */}
                        {orderDateError ? (
                          <div className="text-danger f-12">
                            {orderDateError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={4} className="notrequired-date-endDate">
                      <FormGroup>
                        <Label>Received Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <DatePicker
                            id="receivedDate"
                            name="receivedDate"
                            selected={receivedDate}
                            // minDate={orderDate ? new Date(orderDate) : new Date()}
                            minDate={orderDate ? new Date(orderDate) : null}
                            maxDate={new Date()}
                            onChange={(e) => {
                              handleReceiveDate(e);
                            }}
                            disabled={isCreditReturnChecked}
                            onChangeRaw={handleReceiveDateRaw}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Select a date"
                            autoComplete="off"
                            className={
                              isCreditReturnChecked
                                ? "required disabled"
                                : "required"
                            }
                            customInput={
                              <ReactInputMask
                                mask="99/99/9999"
                                value={receivedDate}
                              // maskChar=''
                              />
                            }
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("receivedDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4} className="notrequired-date-endDate">
                      <FormGroup>
                        <Label>Invoiced Date</Label>
                        <InputGroup
                          onMouseLeave={handleMouseLeave}
                          style={{ zIndex: 99999 }}
                        >
                          <DatePicker
                            id="invoiceDate"
                            name="invoiceDate"
                            selected={invoiceDate}
                            onChange={(e) => {
                              handleInvoiceDate(e);
                            }}
                            onChangeRaw={handleInvoiceDateRaw}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Select a date"
                            autoComplete="off"
                            minDate={(orderDate && receivedDate) ? new Date(receivedDate) : null || orderDate ? new Date(orderDate) : null}
                            maxDate={new Date()}
                            // minDate={
                            //   receivedDate ? new Date(receivedDate) : new Date()
                            // }
                            customInput={
                              <ReactInputMask
                                mask="99/99/9999"
                                value={invoiceDate}

                              // maskChar=''
                              />
                            }
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("invoiceDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {invoiceDateError ? (
                          <div className="text-danger f-12">
                            {invoiceDateError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={4} className="notrequired-date-endDate">
                      <FormGroup>
                        <Label for="Invoice Number">Invoice #</Label>
                        <Input
                          // id="InoviceNumber"
                          name="InoviceNumber"
                          type="text"
                          placeholder="Invoice Number"
                          autoComplete="off"
                          value={invoiceid}
                          onChange={(e) => {
                            handleinvoice(e);
                          }}
                        />
                        {invoiceError ? (
                          <div className="text-danger f-12">
                            {invoiceError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md={3} lg={3} sm={6} xs={6}>
                      {" "}
                      <FormGroup style={{ marginTop: "25px", marginLeft: "10px" }}>
                        <Label for="file.">Attach File...</Label>

                        <Button
                          className="text-primary text-decoration-none ms-2 p-2"
                          color="link"
                          onClick={() => manvalPharmacy()}
                          title="Upload Attachments"
                        >
                          <HoverImage
                            src={Attachments}
                            hoverSrc={Attachments_hover}
                            alt=""
                          />
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>
                        <Row>
                    <Col md={12}>
                      <div
                        className="mb-3"
                        style={{
                          background: "#DBC8D8",
                          color: "#702C62",
                          padding: "8px 12px",
                          borderRadius: "4px",
                          width: "fit-content",
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <img
                          src={InfoIcon}
                          alt="Info"
                          style={{
                            width: "16px",
                            height: "16px",
                            flexShrink: 0,
                            marginTop: "2px",
                          }}
                        />
                        <p className="m-0 f-14 ms-2 ">
                          Complete is enabled after entering Invoiced Date,
                          Invoice #, Invoiced Qty and Package Price. If this
                          information is not yet available, the order can be
                          Saved with an Order Open status to allow future edits.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </>
              );
            }}
          ></Formik>

          <div className="table-card">
            <div
              className="table-responsive"
              style={{ minHeight: "200px", borderRadius: "7px" }}
            >
              <table className="table theme-table" >
                <thead style={{ borderRadius: "5px", }}>
                  <tr>
                    <th width={100}>Options</th>
                    <th width={150}>NDC/NDC Description</th>
                    {/* <th width={180}>NDC Description</th> */}
                    <th width={120}>Qty Ordered</th>
                    <th width={120}>Qty Received</th>
                    <th width={120}>Qty Invoiced</th>
                    <th width={140}>Package Price</th>
                    <th width={170}>Total Price</th>
                    <th width={120}>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  <Formik
                    innerRef={formikRef}
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    // validationSchema={validationSchema}
                    enableReinitialize={true}
                    children={(props) => {
                      const {
                        isSubmitting,
                        handleSubmit,
                        setSubmitting,
                        setFieldValue,
                        errors,
                        values,
                        touched
                      } = props;
                      return (
                        <tr style={{ backgroundColor: "#f2f7fa" }}>
                          <td>
                            <Button
                              disabled={isSubmitting}
                              //onClick={handleAddRow}
                              onClick={handleSubmit}
                              type="submit"
                              color="link"
                            >
                              <FontAwesomeIcon
                                icon={faPlusCircle}
                                className="text-primary f-22"
                              />
                            </Button>
                          </td>
                          <td
                            colSpan="1"
                            style={{
                              paddingLeft: "1px",
                              width: "300px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <NDCList
                              requiredflag={true}
                              name="ndc"
                              onSelect={(value) => handleNdc(value, setFieldValue)}
                              selectedNDC={selectedNdc}
                              add={"NDC or Drug Description"}
                            />
                            {ndcexisterror &&
                              <div style={{ color: "red" }}>
                                {ndcexisterror}
                              </div>}
                          </td>
                          <style>
                            {`
                          input[type="number"]::-webkit-outer-spin-button,
                          input[type="number"]::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                            margin: 0;
                          }
                          input[type="number"] {
                            -moz-appearance: textfield;
                          }
                        `}
                          </style>
                          <td style={{ width: "75px" }}>
                            <Field
                              id="qtyordered"
                              name="qtyordered"
                              type="number"
                              autoComplete="off"
                              component={FormikInputField}
                              className={
                                isCreditReturnChecked
                                  ? "required disabled"
                                  : "required"
                              }
                              style={{ height: 42, width: 71, borderRadius: 5 }}
                              disabled={isCreditReturnChecked}
                            />
                            {touched.qtyordered && values.qtyordered == "" && !isCreditReturnChecked ? (
                              <div className="text-danger f-12">
                                {errqtyOrder ? errqtyOrder : errqtyOrder1}
                              </div>
                            ):null}

                          </td>
                          <td style={{ width: "75px" }}>
                            <Field
                              id="qtyreceived"
                              name="qtyreceived"
                              type="number"
                              autoComplete="off"
                              component={FormikInputField}
                              // className={
                              //   isCreditReturnChecked
                              //     ? "disabled"
                              //     : ""
                              // }
                              style={{ height: 42, width: 76, borderRadius: 5 }}
                              disabled={isCreditReturnChecked || invoiceDate==null || invoiceid==""}
                            />
                          </td>
                          <td style={{ width: "75px" }}>
                            <Input
                              id="qtybilled"
                              name="qtybilled"
                              type="number"
                              value={qtyBilled}
                              autoComplete="off"
                              //component={FormikInputField}
                              className={invoiceDate==null || invoiceid=="" ? null : "required"}
                              style={{ height: 42, width: 71, borderRadius: 5 }}
                              onChange={(e) => {
                                handleQtyBilledChange(e, setFieldValue);
                              }}
                              disabled={!isCreditReturnChecked &&(invoiceDate == null || invoiceid === "")}
                            />
                            {/* {errors.qtybilled && (
                          <div className="text-danger f-12">
                            {errors.qtybilled}
                          </div>
                        )} */}
                          </td>
                          <td style={{ width: "10px" }}>
                            <Field
                              id="packagesprice"
                              name="packagesprice"
                              type="number"
                              autoComplete="off"
                              // className="required"
                              component={FormikInputField}
                              //onChange={(value) => handlepackagesprice(value, setFieldValue)}
                              style={{ height: 42, width: 90, borderRadius: 5 }}
                            />
                          </td>
                          <td style={{ width: "80px" }}>
                            {values.packagesprice && values.qtybilled ? (
                              // <div>
                              //   ${(values.packagesprice * values.qtybilled).toFixed(
                              //     2
                              //   )}{" "}

                              // </div>
                              <div>
                                {values.packagesprice * values.qtybilled < 0 ? (
                                  <span>
                                    -${Math.abs(values.packagesprice * values.qtybilled).toFixed(2)}
                                  </span>
                                ) : (
                                  <span>
                                    ${(values.packagesprice * values.qtybilled).toFixed(2)}
                                  </span>
                                )}
                              </div>
                            ) : null}
                          </td>
                          <td>
                            <Field
                              id="comment"
                              name="comment"
                              type="textarea"
                              autoComplete="off"
                              rows={1}
                              component={FormikInputField}
                              style={{ width: "160px" }}
                            />
                          </td>
                        </tr>
                      );
                    }}
                  />
                  {rows.map((item) => {
                    return (
                      <Formik
                        key={item.id}
                        initialValues={{
                          ndc: item.Desc,
                          //accumulation: item.accumulation,
                          qtyordered: item.qtyordered,
                          qtyreceived: item.qtyreceived,
                          qtybilled: item.qtybilled,
                          packagesprice: item.packagesprice,
                          totalprice: item.qtybilled * item.packagesprice,
                          comment: item.comment,
                        }}
                        //validationSchema={validationSchema}
                        enableReinitialize={true}
                        children={(props) => {
                          const { values, setFieldValue } = props;
                          return (
                            <tr
                              key={item.id}
                              style={{ backgroundColor: "#f2f7fa" }}
                            >
                              <td>
                                <div className="d-flex align-items-center">
                                  <Button
                                    title="Edit"
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    hidden={isEditable === item.id}
                                    onClick={() => toggleEdit(item, true)}
                                  >
                                    <HoverImage
                                      src={EditIcon}
                                      hoverSrc={EditHoverIcon}
                                      alt=""
                                    />
                                  </Button>

                                  <Button
                                    hidden={isEditable !== item.id}
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    onClick={() => savePanelUpdateRow(item,values)}
                                  >
                                    <HoverImage
                                      key="SaveIcon"
                                      src={SaveIcon}
                                      hoverSrc={SaveHoverIcon}
                                      alt=""
                                    />
                                  </Button>
                                  <Button
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    hidden={isEditable !== item.id}
                                    onClick={oncancal}
                                  >
                                    <HoverImage
                                      key="CancelIcon"
                                      src={CancleIcon}
                                      hoverSrc={CancleHoverIcon}
                                      alt=""
                                    />
                                  </Button>
                                  <Button
                                    title="Delete"
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    onClick={() => onHandleDelete(item.id)}
                                  // hidden={true}
                                  >
                                    <HoverImage
                                      src={Download}
                                      hoverSrc={DownlaodHower}
                                      alt=""
                                    />
                                  </Button>
                                </div>
                              </td>

                              {/* <td className="flex align-items-center">
                                <td>{item.ndc.padStart(11, '0')}</td>
                                <td width={0}>{item.Desc}</td>
                              </td>
                              <td width={30}>{item.Desc}</td> */}
                              <td className="flex align-items-center">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <span>{item.ndc.padStart(11, '0')}</span>
                                 
                                  <div style={{
                                    width: '1px',
                                    height: '40px',
                                    backgroundColor: '#ccc', // light gray
                                    opacity: 0.6,             // slightly faded
                                    margin: '0 10px'
                                  }}></div>

                                  <span>{item.Desc}</span>
                                </div>
                              </td>
                              <td>
                                {values.qtyordered ? (
                                  <div>{values.qtyordered}</div>
                                ) : null}
                              </td>
                              {isEditable1 == true && isEditable === item.id ? (
                                <td>
                                  <Input
                                    id="qtyreceived"
                                    name="qtyreceived"
                                    type="number"
                                    defaultValue={item.qtyreceived}
                                    //value={receivedBilled ? receivedBilled : item.qtyreceived}
                                    autoComplete="off"
                                    component={FormikInputField}
                                    // className="required"
                                    disabled={invoiceDate == null || invoiceid === ""}
                                    style={{ height: 42, width: 71, borderRadius: 5 }}
                                    // onChange={(e) => {
                                    //   handlereceievdChange(e, setFieldValue);
                                    // }}
                                    onChange={(e) => {
                                      setFieldValue("qtyreceived", e.target.value);
                                      handlereceievdChange(e, setFieldValue);}}
                                  />
                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  {/* {values?.qtyreceived} */}
                                  {values?.qtyreceived !== undefined &&
                                    values?.qtyreceived !== 0
                                    ? values.qtyreceived
                                    : ""}
                                </td>
                              )}
                              {isEditable1 == true && isEditable === item.id ? (
                                <td>
                                  <Input
                                    id="qtybilled"
                                    name="qtybilled"
                                    type="number"
                                    defaultValue={item.qtybilled}
                                    //value={billqty ? billqty : item.qtybilled}
                                    autoComplete="off"
                                    style={{ height: 42, width: 71, borderRadius: 5 }}
                                    onChange={(e) => {
                                      handlbillChange(e, setFieldValue);
                                    }}
                                    className={invoiceDate==null || invoiceid=="" ? null : "required"}
                                    disabled={invoiceDate == null || invoiceid === ""}
                                  />

                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  {/* {values?.qtybilled} */}
                                  {values?.qtybilled !== undefined &&
                                    values?.qtybilled !== 0
                                    ? values.qtybilled
                                    : ""}
                                </td>
                              )}
                              {isEditable1 == true && isEditable === item.id ? (
                                <td>
                                  <Input
                                    id="packagesprice"
                                    name="packagesprice"
                                    type="number"
                                    defaultValue={item.packagesprice}
                                    //value={packageprice ? packageprice : item.packagesprice}
                                    autoComplete="off"
                                    style={{ height: 42, width: 103, borderRadius: 5 }}
                                    onChange={(e) => {
                                      handlepackagepriceChange(e, setFieldValue);
                                    }}
                                  />
                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  {/* {values?.packagesprice !== undefined &&
                                    values?.packagesprice !== 0
                                    ? `$${(values.packagesprice).toFixed(2)}`
                                    : ""} */}
                                    {values.packagesprice !== "" &&
                                    values.packagesprice !== undefined &&
                                    values.packagesprice !== null
                                    ? `$${Number(values.packagesprice).toFixed(2)}` : "$0.00"}
                                </td>
                              )}
                              <td>
                                {values.packagesprice && values.qtybilled ? 
                                (<div>
                                  ${(Number(values.qtybilled) * Number(values.packagesprice)).toFixed(2)}
                                </div>) : "$0.00"}
                                {/* <Field
                            id="totalprice"
                            name="totalprice"
                            type="text"
                            autoComplete="off"
                            component={FormikInputField}
                            style={{ height: 42, width: 71, borderRadius: 5 }}
                          /> */}
                              </td>

                              {isEditable1 == true && isEditable === item.id ? (
                                <td>
                                  <Field
                                    id="comment"
                                    name="comment"
                                    type="textarea"
                                    autoComplete="off"
                                    rows={1}
                                    component={FormikInputField}
                                    style={{ width: "160px" }}
                                  //disabled={!isEditable}
                                  >
                                    {values.comment ? (
                                      <div>{values.comment}</div>
                                    ) : null}
                                  </Field>
                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  {values?.comment}
                                </td>
                              )}
                            </tr>
                          );
                        }}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{ float: "right" }} className="mt-3">


              <Button color="primary" onClick={toggle} className="reset" disabled={state.rows.length === 0}>
                <span className="right_5"><img src={cancel} alt="" /></span> Cancel
              </Button>
              <Button
                color="primary"
                className="search"
                onClick={handleorder}
                disabled={isflag == false || invoiceDate==null || invoiceid=="" || state.rows.length === 0}
              >
                <span className="right_5"><img src={complete} alt="" /></span> Complete
              </Button>
              <Button
                color="primary"
                className="search"
                onClick={handlesave}
                disabled={isflag == false || isCreditReturnChecked || invoiceDate!=null || invoiceid!="" || state.rows.length === 0}
              >
                <span className="right_5"><img src={save} alt="" /></span> Save
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>
      <Drawer
        direction="end"
        isOpen={AddAtachments}
        toggle={manvalPharmacy}
        size="lg"
        title="Add Attachments"
      >
        <ProgramNotes
          orgId={orgId}
          onClose={manvalPharmacy}
          selectedCoveredEntity={coveredEntityIDs}
        />
      </Drawer>
    </div>
  );
};

export default AddPurchaseOrder;
